import { createContext } from "react";
export var RecordContext = createContext({});
